import styled from 'styled-components';
export const ContentWrapper = styled.div `
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;
